/**
 * Mascot Presence domain — Djay's proactive-voice budget & cadence.
 * App-Feel 2027 §3B / §5.2 seam #1 ("Djay is Aanwezig, met Cadans").
 */
export {
  PROACTIVE_PRIORITY,
  PRESENCE_POLICY,
  PROACTIVE_BUBBLE_MS,
  priorityOf,
  type ProactiveKind,
  type PresenceRequest,
} from './presenceTypes'
export {
  createPresenceState,
  evaluatePresence,
  commitSpoke,
  pickHighestPriority,
  type PresenceState,
  type PresenceVerdict,
  type PresenceContext,
} from './presenceOrchestrator'
export {
  usePresenceOrchestrator,
  type UsePresenceOrchestratorReturn,
} from './usePresenceOrchestrator'
